// @flow
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  checkForEretlClient,
  checkUserAccessOnRoute
} from '../services/helpers';

// this routesConfig arr is also used in server/route.js
import routesConfig from '../configs/routesConfig';
import config from '../configs/envConfig';
import { PanelConstants } from '../services/utils';

const redirectToDefaultRoute = userProfile => {
  if (
    window.location.hostname === config.eRetailUrl &&
    checkForEretlClient(userProfile)
  ) {
    return <Redirect to={{ pathname: PanelConstants.newPrqPage }} />;
  }
  return <Redirect to={{ pathname: PanelConstants.defaultRoute }} />;
};

const getFirstLevelRoutes = () => {
  const newRoutesArray = [];
  routesConfig.map(routeObj => {
    if (routeObj.zoomuinewroute) {
      newRoutesArray.push(routeObj);
    } else if (routeObj.subRoutes && routeObj.subRoutes.length > 0) {
      routeObj.subRoutes.map(subRouteObj => {
        if (subRouteObj.zoomuinewroute) {
          newRoutesArray.push(subRouteObj);
        }
        return null;
      });
    }
    return null;
  });
  return newRoutesArray;
};

const routesArr = getFirstLevelRoutes();

type Props = {
  userProfile: Object,
  history: Object
};

const RouterComp = ({ userProfile, history }: Props) => (
  <div className="routes-wrapper">
    <Switch>
      {routesArr.map((route: Object) => (
        <Route
          key={route.title}
          path={route.route}
          exact={route.exact}
          history={history}
          render={renderProps => {
            const pathStr = renderProps.match.path.split('/')[1];
            const hasRouteAccess = checkUserAccessOnRoute(
              pathStr,
              userProfile,
              routesConfig
            );
            return hasRouteAccess ? (
              <route.component
                history={history}
                routeProps={route.routeProps}
                params={renderProps.match.params}
              />
            ) : (
              redirectToDefaultRoute(userProfile)
            );
          }}
        />
      ))}
    </Switch>
  </div>
);

export default RouterComp;
